
import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { BsCalendar } from 'react-icons/bs';
import { addDays } from '../utils/dateUtils';

const CheckOut = ({ selectedDate, onChangeDate, checkInDate, minDate }) => {
  const checkInMin = checkInDate ? addDays(checkInDate, 1) : null;
  const effectiveMin = checkInMin && minDate
    ? (checkInMin > minDate ? checkInMin : minDate)
    : checkInMin || minDate;

  return (
    <div className="flex items-center space-x-2 w-full">
      <BsCalendar className="text-yellow-500 text-lg shrink-0" />
      <DatePicker
        id="checkOut"
        className="bg-transparent w-full text-gray-800 text-sm font-semibold focus:outline-none"
        selected={selectedDate}
        onChange={onChangeDate}
        minDate={effectiveMin}
        dateFormat="EEE dd MMM yyyy"
        placeholderText="Check-out"
      />
    </div>
  );
};

export default CheckOut;
